export enum ActionTypes {
  FETCH_REPORTS = "reports-module/fetch-reports",
  FETCH_REPORT = "reports-module/fetch-report",
  FETCH_PDF = "reports-module/fetch-pdf",
  SEND_REPORT = "reports-module/send-report",
}
